"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _InstrumentSelectorContainer = _interopRequireDefault(require("../InstrumentSelector/InstrumentSelectorContainer"));
var _InstrumentTableContainer = _interopRequireDefault(require("../InstrumentTable/InstrumentTableContainer"));
require("./InstrumentRowComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var InstrumentRowComponent = function InstrumentRowComponent() {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_InstrumentSelectorContainer["default"], null), /*#__PURE__*/_react["default"].createElement(_InstrumentTableContainer["default"], null));
};
var _default = exports["default"] = InstrumentRowComponent;